import Swiper from "swiper/bundle";

const SwiperHandler = {
  init: () => {
    // swiper header
    const swiperHeader = new Swiper("#swiper-header", {
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000,
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
    });

    // swiper reviews
    const swiperReviews = new Swiper("#swiper-reviews", {
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
    });
  },
};

export default SwiperHandler;
